import React, { useContext, useEffect, useState } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material//CardContent'
import {
  CardActions,
  CardMedia, Divider,
  IconButton, ToggleButton,
  Typography
} from '@mui/material'
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import ShareIcon from '@mui/icons-material/Share'
import ChatIcon from '@mui/icons-material/Chat'
import { AuthTokenContext } from '../../../contexts/AuthTokenContext'
import { Link, useNavigate } from 'react-router-dom'
import PostCardHeader from './PostCardHeader'
import voteService from '../../../../services/voteService'
import VoteToggleButtonGroup from '../../../commonUIComponents/VoteToggleButtonGroup'
import { UserInfoContext } from '../../../contexts/UserInfoContext'

const PostCard = ({ post, fetchPosts, updateVote }) => {
  const { authToken } = useContext(AuthTokenContext)
  const { userInfo } = useContext(UserInfoContext)
  const { id } = post
  const navigate = useNavigate()
  const [vote, setVote] = useState(null)

  const onClickPostHandler = event => {
    event.preventDefault()
    navigate(`/view-post/${id}`)
  }

  const toggleOnChangeHandler = (event, value) => {
    setVote(value)
    voteService.updatePostVote(id, value)
      .then(res => {
        updateVote(id, res.myVote, res.votes)
      })
  }

  useEffect(() => {
    if (post.myVote === -1) {
      setVote('dislike')
    } else if (post.myVote === 0) {
      setVote(null)
    } else if (post.myVote === 1) {
      setVote('like')
    }
  }, [])

  return (
    <>
      <Card
        elevation={0}
        sx={{
          maxWidth: 900,
          maxHeight: 700,
          borderRadius: '16px',
          ':hover': {
            boxShadow: 6,
            backgroundColor: '#181c20'
          }
        }}
      >
        <PostCardHeader authToken={authToken} post={post} fetchPosts={fetchPosts} />
        <CardContent
          onClick={onClickPostHandler}
          sx={{
            textDecoration: 'none',
            p: 0,
            '&:last-child': { p: 0 }
          }}
        >
          <Typography variant="h6" color="common.white" component="p" sx={{ pl: '1rem', mt: '-1rem' }}>
            {post.title}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            component="p"
            sx={{ pl: '1rem' }}
            dangerouslySetInnerHTML={{ __html: post?.body }}
          />
          <Typography variant="body1" color="text.secondary" component="p" sx={{ pl: '1rem' }}>
            {post.link}
          </Typography>
          {post.images?.map(image => (
            <CardMedia
              key={image}
              component="img"
              sx={{
                objectFit: 'contain',
                paddingTop: '0.5rem',
                maxWith: '724px',
                maxHeight: '540px'
              }}
              image={image}
              alt="image"
            />
          ))}
        </CardContent>
        <CardActions disableSpacing sx={{ mt: -1 }}>
          <VoteToggleButtonGroup
            value={vote}
            exclusive
            onChange={toggleOnChangeHandler}
            aria-label="text alignment"
            disabled = {!authToken}
          >
            <ToggleButton value="like" aria-label="like">
              <KeyboardArrowUpOutlinedIcon />
            </ToggleButton>
            <ToggleButton value="" aria-label="voteCount" disabled>
              <Typography variant="subtitle2">{post.votes}</Typography>
            </ToggleButton>
            <ToggleButton value="dislike" aria-label="dislike">
              <KeyboardArrowDownOutlinedIcon />
            </ToggleButton>
          </VoteToggleButtonGroup>
          <IconButton aria-label="comment" to={`/view-post/${id}`} component={Link} sx={{ textDecoration: 'none' }}>
            <ChatIcon />
          </IconButton>
          <IconButton aria-label="share" disabled>
            <ShareIcon />
          </IconButton>
        </CardActions>
      </Card>
      <Divider/>
    </>
  )
}

export default PostCard
